import { render, staticRenderFns } from "./contacts-segment-edit.vue?vue&type=template&id=77467bc0&"
import script from "./contacts-segment-edit.vue?vue&type=script&lang=js&"
export * from "./contacts-segment-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports